import styled from "styled-components";
import {useSelector} from "react-redux";
import useSortArray from "../../../../../common/hooks/useSortArray";
import useChampionFunc from "../../../../../common/hooks/useChampionFunc";
import React, {useMemo} from "react";
import InternalServerError from "../../../../common/InternalError";
import {Loading} from "../../../../common";
import ArmRankTableHeader from "../../../../Aram/AramContent/AramRank/AramRankTable/ArmRankTableHeader";
import URFRankTableContent from "./urfRankTableContent";
import URFRankTableModel from "../../../../../Model/URFRankTableModel";

const Wrapper = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const TBody = styled.tbody`

  tr:nth-child(even) {
    background-color: ${props => props.theme.color.background_F2F4};
  }
`;


const initSort = [{
    value: 'rank', sortType: false, reverseSort: true,
}];

const initSortList = {
    rank: {
        value: 'rank', sortType: false, reverseSort: true,
    }, tier: {
        value: 'tier', sortType: true, reverseSort: true,
    }, win_rate: {
        value: 'win_rate', sortType: true,
    }, pick_rate: {
        value: 'pick_rate', sortType: true,
    }, dpm: {
        value: 'dpm', sortType: true,
    }, pentakills: {
        value: 'pentakills', sortType: true,
    },
}

const  URFRankTable = ({ranks = [], pageValue = 99}) => {
    const version = useSelector((state) => state.gameVersion.version);
    const {
        getChampionsRankLoading, getChampionsRankError
    } = useSelector((state) => state.champions);
    const {sort, sortList, onClickSort} = useSortArray({
        initSort: initSort, initSortList: initSortList,
    });
    const {getChampion} = useChampionFunc();


    const model = useMemo(() => new URFRankTableModel(ranks, sort), [sort, ranks]);



    if (getChampionsRankError) return (<InternalServerError/>);
    if (getChampionsRankLoading) return (<Loading/>);

    if (ranks.length === 0) return (<InternalServerError errorText={"There are no data"}/>);

    return (<Wrapper>
        <colgroup>
            <col width={'12%'}/>
            <col width={'20%'}/>
            <col width={'8%'}/>
            <col width={'10%'}/>
            <col width={'10%'}/>
            <col width={'20%'}/>
            <col width={'13%'}/>
        </colgroup>
        <thead>
        <ArmRankTableHeader
            currentSort={sort}
            onClickSort={onClickSort}
            sortData={sortList}
        />
        </thead>
        <TBody>
            {Array.isArray(model.sortedList) && model.sortedList.slice(0, pageValue).map((data, index) => {

                return (
                    <URFRankTableContent
                        tier={data.tier}
                        rankDelta={data.rank_delta}
                        champion={getChampion(data.champion_id)}
                        pickRate={data?.pick_rate}
                        winRate={data?.win_rate}
                        highestDPM={model.highestValue}
                        dpm={data?.dpm}
                        key={`${data.rank}aramTable${data.champion_id}`}
                        rank={data.rank}
                        pentaKills={data?.pentakills}
                        version={version}
                    />)
            })}
        </TBody>
    </Wrapper>);
};



export default URFRankTable;
